import "core-js/modules/es6.symbol.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { stringify } from 'qs';
import * as types from './types';
import fetchCategory from '~/services/category';
var MOCK_ORIGIN_URL = 'https://mock';
export default {
  fetchContent(_ref, _ref2) {
    var _this = this;
    return _asyncToGenerator(function* () {
      var {
        commit
      } = _ref;
      var {
        alias,
        query,
        profileId
      } = _ref2;
      var {
        category
      } = yield fetchCategory(_this, alias, query, profileId);
      if (!category) {
        commit(types.SET_PRODUCTS, {
          products: [],
          total: 0
        });
        return;
      }
      var {
        details,
        total,
        products,
        earlybirdsWidgets
      } = category;
      var {
        currentLocale
      } = _this.state.i18n;
      var currentQuery = Object.keys(query).length ? "?".concat(stringify(query)) : '';
      var currentAlias = "".concat(details.slug, "-").concat(details.hash);
      if (alias !== currentAlias && process.server && details.slug !== null) {
        _this.app.context.redirect(301, "/".concat(currentLocale.market, "/").concat(currentLocale.language, "/c/").concat(currentAlias).concat(currentQuery));
      }
      var isRedirect = details.routing && details.routing.isRedirect;
      if (isRedirect) {
        var redirectData = details.routing;
        if (process.server && redirectData.newUrl) {
          _this.app.context.redirect(redirectData.httpCode, "".concat(redirectData.newUrl).concat(currentQuery));
        } else {
          var url = new URL(redirectData.newUrl, MOCK_ORIGIN_URL);
          var redirectUrl = url.href.replace('mock/', '');
          if (redirectUrl.match(/^\/[A-Z]{2}\/[a-z]{2}\/(?:c|e|p|q|s)\//)) {
            _this.app.context.redirect(301, "".concat(redirectUrl).concat(currentQuery));
          } else {
            window.location.href = "".concat(redirectUrl).concat(currentQuery);
          }
        }
        return;
      }
      commit(types.SET_DESCRIPTION, _objectSpread(_objectSpread({}, details), {}, {
        earlybirdsWidgets
      }));
      commit(types.SET_PRODUCTS, {
        products,
        total
      });
    })();
  },
  appendProducts(_ref3, _ref4) {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      var {
        commit
      } = _ref3;
      var {
        alias,
        query,
        profileId
      } = _ref4;
      var {
        category: {
          products
        }
      } = yield fetchCategory(_this2, alias, query, profileId);
      commit(types.APPEND_PRODUCTS, products);
    })();
  },
  prependProducts(_ref5, _ref6) {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      var {
        commit
      } = _ref5;
      var {
        alias,
        query,
        profileId
      } = _ref6;
      var {
        category: {
          products
        }
      } = yield fetchCategory(_this3, alias, query, profileId);
      commit(types.PREPEND_PRODUCTS, products);
    })();
  }
};